import axios, { AxiosResponse, AxiosError } from 'axios';
import { API_BASE_URL } from '../constants';

// Create axios instance for RFP endpoints
const httpClientRFP = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'ngrok-skip-browser-warning': 'true',
    'Content-Type': 'application/json',
  },
});

// Request interceptor - Add RFP token and timezone to requests
httpClientRFP.interceptors.request.use(
  config => {
    // Get RFP token from sessionStorage (different from auth token)
    const rfpToken = sessionStorage.getItem('aloRfpToken');

    if (rfpToken) {
      config.headers.Authorization = `Bearer ${rfpToken}`;
    }

    // Add browser's timezone to all requests
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    config.headers['X-Timezone'] = timezone;

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Response interceptor - Handle RFP-specific errors
httpClientRFP.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  (error: AxiosError) => {
    console.error('RFP HTTP Error:', error);

    if (error.response) {
      const { status, data } = error.response;

      switch (status) {
        case 401:
          // Unauthorized - clear RFP token and trigger re-authentication
          console.error('RFP token invalid or expired');
          sessionStorage.removeItem('aloRfpToken');
          // The RFPAuthGuard will detect missing token and show consent flow
          // window.location.reload();
          break;
        case 403:
          // Forbidden
          const errorMessage =
            (data as any)?.message ||
            'You do not have permission to access this RFP.';
          console.error('403 RFP Error:', errorMessage);
          break;
        case 404:
          console.error('RFP resource not found');
          break;
        case 410:
          console.error('RFP link expired or invalid');
          break;
        case 500:
          console.error('500 Server Error:', data);
          break;
        default:
          console.error('An error occurred:', data);
      }
    } else if (error.request) {
      console.error('Network error - please check your connection');
    } else {
      console.error('Request failed:', error.message);
    }

    return Promise.reject(error);
  }
);

export default httpClientRFP;
